import React, {ReactNode} from 'react';
import I18n from 'app/i18n';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

interface PropsInterface {
    bonusType: string
    active: boolean
    onClick: () => void
    isNoBonusType?: boolean
}

export default class DepositBonusTypeButton extends React.Component<PropsInterface> {
    onClick = (): void => {
        this.props.onClick();
    };

    render(): ReactNode {
        const {active, bonusType, isNoBonusType} = this.props;

        return <button
            className={`deposit-bonus-button ${active ? 'active' : ''}`}
            onClick={this.onClick}
        >
            <div className={`deposit-bonus-button__wrapper ${isNoBonusType ? 'deposit-bonus-button__wrapper--no-bonus' : ''}`}>
                {isNoBonusType
                    ? <SpriteIcon name="#svg-card-logo" size={{height: 56, width: 56}} />
                    : <p className="deposit-bonus-button__wrapper-text">
                        +100%
                        <span>{I18n.t('bonus')}</span>
                    </p>}
            </div>
            <p className="deposit-bonus-button__title">
                {I18n.t(`promo_bonus_${bonusType}`)}
            </p>
        </button>;
    }
}
